<template>
  <div class="input-text w-full">
    <div class="text-on-surface dark:text-on-surface-dark relative w-full rounded-md">
      <div
        class="absolute top-1/2 left-2 -translate-y-1/2 transform"
        :class="
          $attrs.disabled
            ? 'text-gray-lighten-1/50! bg-gray-lighten-1/5! dark:surface/5! cursor-not-allowed!'
            : ''
        "
      >
        <slot name="before-input" />
      </div>
      <input
        v-bind="$attrs"
        v-model="modelValue"
        :type="($attrs.type as string) ?? 'text'"
        ref="input"
        draggable="false"
        :disabled="disabled"
        class="surface focus:border-secondary focus:ring-secondary disabled:dark:bg-surface/5! block w-full rounded-md border-none px-2 py-1 leading-none select-none focus:ring-2 disabled:cursor-not-allowed! disabled:bg-gray-50! disabled:text-gray-400! sm:text-sm"
        :class="[
          $slots['before-input'] ? 'pl-8' : '',
          errors?.length > 0 ? 'text-error ring-error placeholder:text-error focus:ring-error' : ''
        ]"
      />
      <slot name="after-input" />
      <div
        v-if="errors?.length > 0"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
        :class="[$slots['after-input'] ? 'pr-8' : '']"
      >
        <FontAwesomeIcon :icon="['fas', 'circle-exclamation']" size="lg" class="text-error" />
      </div>
    </div>
    <!-- Error message -->
    <p v-if="errors.length > 0" class="text-error mt-2 text-sm">
      {{ errors[0].$message }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue"
import type { ErrorObject } from "@vuelidate/core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

const modelValue = defineModel<string | null | undefined>({ default: undefined })

const props = withDefaults(
  defineProps<{
    errors?: ErrorObject[]
    disabled?: boolean
    autoFocus?: boolean
  }>(),
  {
    modelValue: "",
    errors: () => [],
    disabled: false
  }
)

defineOptions({
  inheritAttrs: false
})

const input = ref<HTMLInputElement>()

function focus() {
  if (input.value) {
    input.value.focus()
  }
}

defineExpose({
  focus
})

onMounted(() => {
  if (props.autoFocus) {
    focus()
  }
})
</script>

<style scoped></style>
